import type { ReactNode } from "react";
import Text from "../../../design-system/primitives/components/Text/Text";
import styles from "./InvitePanel.css";
import StarfieldBackground from "../../../design-system/primitives/components/StarfieldBackground/StarfieldBackground";

type InvitePanelProps = {
  title: string;
  description: string;
  background?: "stars";
  children?: ReactNode;
} & (
  | {
      action: ReactNode;
      actionPosition: "header" | "footer";
    }
  | { action?: never; actionPosition?: never }
);

const InvitePanel = ({
  title,
  description,
  action,
  actionPosition,
  background,
  children,
}: InvitePanelProps) => (
  <div className={styles.root}>
    {background === "stars" && (
      <div className={styles.background}>
        <StarfieldBackground />
      </div>
    )}
    <div className={styles.header}>
      <div className={styles.headerText}>
        <Text variant="subheader" color="neutral-0">
          {title}
        </Text>
        <Text variant="body" color="neutral-100">
          {description}
        </Text>
      </div>
      {actionPosition === "header" && action}
    </div>
    <div className={styles.body}>{children}</div>
    {actionPosition === "footer" && (
      <div className={styles.footer}>{action}</div>
    )}
  </div>
);

export default InvitePanel;
